// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__ZY6LR","gridListV1":"styles_gridListV1__CUM7S"};